webpackJsonp([40228349930423],{

/***/ 1072:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---layouts-split-a0e39f21c11f6a62c5ab.js